const ARRAY_MAX_LENGTH = 100;
const ARRAY_MIN_VALUE = 10;
const ARRAY_MAX_VALUE = 350 * 2;
const ANIMATION_SPEED = 5;

export { ARRAY_MAX_LENGTH, ARRAY_MIN_VALUE, ARRAY_MAX_VALUE, ANIMATION_SPEED };
